// Electron detection & IPC helpers (safe on web).
// When running under Electron, `window.hasyapi` is exposed by preload.js.
export const electron = typeof window !== "undefined" ? window.hasyapi : null;
export const isDesktop = !!electron?.isDesktop;

export async function getDesktopInfo() {
  if (!electron) return null;
  const [version, platform, logPath] = await Promise.all([
    electron.app.getVersion(),
    electron.app.getPlatform(),
    electron.app.getLogPath(),
  ]);
  return { version, ...platform, logPath };
}

// Persist a value into electron-store (desktop) or localStorage (web).
export async function persistSet(key, value) {
  if (electron) return electron.store.set(key, value);
  localStorage.setItem(`hasyapi:${key}`, JSON.stringify(value));
}

export async function persistGet(key) {
  if (electron) return electron.store.get(key);
  const raw = localStorage.getItem(`hasyapi:${key}`);
  try { return raw ? JSON.parse(raw) : null; } catch { return null; }
}
